module.exports = __webpack_public_path__ + "static/media/like-filled.5b58e8df.svg";